/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { ButtonToggleGroupComponent } from './button-toggle-group';
export * from './button-toggle-group-adapter';
export * from './button-toggle-group-constants';
export * from './button-toggle-group-core';
export * from './button-toggle-group';
export function defineButtonToggleGroupComponent() {
    defineCustomElement(ButtonToggleGroupComponent);
}
